import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

// Icône Soleil qui se lève (Matin)
export const SunriseIcon: React.FC<IconProps> = ({ className = '', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Soleil */}
    <circle cx="12" cy="12" r="4" fill="#FFA500" stroke="#FF8C00" strokeWidth="1"/>
    
    {/* Rayons du soleil */}
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" 
          stroke="#FFA500" strokeWidth="1.5" strokeLinecap="round"/>
    
    {/* Horizon */}
    <path d="M2 18h20" stroke="#8B4513" strokeWidth="2" strokeLinecap="round"/>
    
    {/* Montagnes */}
    <path d="M2 18l3-4 2 2 3-3 2 1 3-2 2 1 3-3 2 2 2-2v8H2z" fill="#90EE90" opacity="0.7"/>
  </svg>
);

// Icône Soleil (Après-midi)
export const SunIcon: React.FC<IconProps> = ({ className = '', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Soleil principal */}
    <circle cx="12" cy="12" r="5" fill="#FFD700" stroke="#FFA500" strokeWidth="1"/>
    
    {/* Rayons du soleil */}
    <path d="M12 1v3M12 20v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M1 12h3M20 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" 
          stroke="#FFD700" strokeWidth="2" strokeLinecap="round"/>
    
    {/* Rayons secondaires */}
    <path d="M12 3.5v1.5M12 19v1.5M5.64 5.64l1.06 1.06M17.3 17.3l1.06 1.06M3.5 12h1.5M19 12h1.5M5.64 18.36l1.06-1.06M17.3 6.7l1.06-1.06" 
          stroke="#FFA500" strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

// Icône Lune (Soir)
export const MoonIcon: React.FC<IconProps> = ({ className = '', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Lune croissant */}
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" 
          fill="#E6E6FA" stroke="#9370DB" strokeWidth="1"/>
    
    {/* Cratères */}
    <circle cx="14" cy="8" r="1" fill="#D8BFD8" opacity="0.6"/>
    <circle cx="16" cy="12" r="0.5" fill="#D8BFD8" opacity="0.6"/>
    <circle cx="13" cy="14" r="0.7" fill="#D8BFD8" opacity="0.6"/>
    
    {/* Étoiles */}
    <path d="M6 4l0.5 1.5L8 6l-1.5 0.5L6 8l-0.5-1.5L4 6l1.5-0.5z" fill="#FFD700"/>
    <path d="M18 5l0.3 0.9L19.2 6l-0.9 0.3L18 7.2l-0.3-0.9L16.8 6l0.9-0.3z" fill="#FFD700"/>
    <path d="M4 16l0.3 0.9L5.2 17l-0.9 0.3L4 18.2l-0.3-0.9L2.8 17l0.9-0.3z" fill="#FFD700"/>
  </svg>
);

// Composant combiné pour faciliter l'utilisation
interface TimeSlotIconProps extends IconProps {
  timeSlot: 'matin' | 'apm' | 'soir';
}

export const TimeSlotIcon: React.FC<TimeSlotIconProps> = ({ timeSlot, ...props }) => {
  switch (timeSlot) {
    case 'matin':
      return <SunriseIcon {...props} />;
    case 'apm':
      return <SunIcon {...props} />;
    case 'soir':
      return <MoonIcon {...props} />;
    default:
      return null;
  }
};